import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Experience',
    href: '#career-timeline'
  }, {
    name: 'Achievements',
    href: '#achievements'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      // Update active section based on scroll position
      const sections = ['hero', 'about', 'career-timeline', 'achievements', 'contact'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-dark-bg/95 backdrop-blur-md border-b border-dark-border py-4' : 'bg-transparent py-6'}`} data-id="element-375">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex justify-between items-center" data-id="element-376">
        <a href="#hero" onClick={e => scrollToSection(e, '#hero')} className="flex items-center gap-3 group" data-id="element-377">
          <div className="w-10 h-10 flex items-center justify-center border border-gold/40 rounded-sm bg-dark-elevated/50 group-hover:border-gold transition-colors" data-id="element-378">
            <span className="font-sans text-sm font-semibold text-gold tracking-wider" data-id="element-379">
              MP
            </span>
          </div>
          <div className="flex flex-col" data-id="element-380">
            <span className="font-sans text-base font-semibold tracking-wide text-white leading-tight" data-id="element-381">
              MICHAEL PARKS
            </span>
            <span className="font-sans text-xs text-gold/60 tracking-wider" data-id="element-382">
              Enterprise Technology Executive
            </span>
          </div>
        </a>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8" data-id="element-383">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className={`text-sm font-medium transition-colors hover:text-white ${activeSection === link.href.substring(1) ? 'text-white' : 'text-slate-300'}`} data-id="element-384">
              {link.name}
            </a>)}
          <a href="#contact" onClick={e => scrollToSection(e, '#contact')} className="px-5 py-2 border border-gold/60 rounded text-sm font-medium text-gold hover:bg-gold/10 transition-all" data-id="element-385">
            Connect
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-386">
          {mobileMenuOpen ? <X data-id="element-387" /> : <Menu data-id="element-388" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-389">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-dark-bg border-b border-dark-border overflow-hidden" data-id="element-390">
            <div className="px-4 py-6 flex flex-col gap-4" data-id="element-391">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-base font-medium text-slate-300 hover:text-white py-2 border-b border-dark-border/50" data-id="element-392">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={e => scrollToSection(e, '#contact')} className="mt-4 px-4 py-3 border border-gold/60 rounded text-center text-gold font-medium hover:bg-gold/10" data-id="element-393">
                Connect
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}